
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/importance-of-talent-management",
      function () {
        return require("private-next-pages/us/importance-of-talent-management/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/importance-of-talent-management"])
      });
    }
  